var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6461 14.6656C5.70429 14.6069 5.77353 14.5603 5.84981 14.5285C5.92609 14.4968 6.00791 14.4804 6.09055 14.4804C6.17318 14.4804 6.255 14.4968 6.33128 14.5285C6.40756 14.5603 6.4768 14.6069 6.53499 14.6656L9.41448 17.5451L9.41448 2.80957C9.41448 2.64355 9.48043 2.48433 9.59782 2.36694C9.71522 2.24954 9.87444 2.18359 10.0405 2.18359C10.2065 2.18359 10.3657 2.24954 10.4831 2.36694C10.6005 2.48433 10.6664 2.64355 10.6664 2.80957L10.6664 17.5325L13.5271 14.6656C13.6444 14.549 13.8031 14.4835 13.9685 14.4835C14.1338 14.4835 14.2925 14.549 14.4098 14.6656C14.5264 14.7829 14.5918 14.9415 14.5918 15.1069C14.5918 15.2723 14.5264 15.4309 14.4098 15.5482L10.4286 19.5294C10.3772 19.583 10.3154 19.6256 10.2471 19.6548C10.1788 19.6839 10.1053 19.6989 10.0311 19.6989C9.95681 19.6989 9.88332 19.6839 9.81501 19.6548C9.7467 19.6256 9.68498 19.583 9.63357 19.5294L5.6461 15.5545C5.58743 15.4963 5.54086 15.427 5.50908 15.3507C5.4773 15.2745 5.46094 15.1926 5.46094 15.11C5.46094 15.0274 5.4773 14.9456 5.50908 14.8693C5.54086 14.793 5.58743 14.7238 5.6461 14.6656Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqArrow);
export default __webpack_public_path__ + "static/media/faqArrow.793ee2991b9975afbeb57eceaf2fc13f.svg";
export { ForwardRef as ReactComponent };